var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_9979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1953 9.38037H7.19531V13.1304H13.1953V9.38037Z",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69531 9.38037V7.13037C8.6965 6.73291 8.85492 6.35207 9.13596 6.07102C9.41701 5.78997 9.79785 5.63156 10.1953 5.63037C10.5928 5.63156 10.9736 5.78997 11.2547 6.07102C11.5357 6.35207 11.6941 6.73291 11.6953 7.13037V9.38037",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 10.8804C16.9453 12.6706 16.2342 14.3875 14.9683 15.6533C13.7024 16.9192 11.9855 17.6304 10.1953 17.6304C8.4051 17.6304 6.68821 16.9192 5.42234 15.6533C4.15647 14.3875 3.44531 12.6706 3.44531 10.8804V3.38037L10.1953 1.88037L16.9453 3.38037V10.8804Z",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_9979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.820312 0.00537109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon3);
export default __webpack_public_path__ + "static/media/product-icon-3.ebb462b057e29db6e6028b3cb7b7b2a0.svg";
export { ForwardRef as ReactComponent };